import { render, staticRenderFns } from "./formError.vue?vue&type=template&id=30ea6d72&"
import script from "./formError.vue?vue&type=script&lang=js&"
export * from "./formError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports